import { gsap } from "gsap";
import { Draggable } from "gsap/Draggable";

gsap.registerPlugin(Draggable);

$(document).ready(function () {
    // console.log("GSAP Draggable initialized");

    const boxes = gsap.utils.toArray(".custom-drag-sticker");
    let active = null;
    let draggableInstances = []; // To save Draggable instances

    function initDraggable() {
        boxes.forEach((box) => {
            const section = box.closest("section");

            gsap.set(box, { clearProps: "transform", x: 0, y: 0 });

            if (section && window.innerWidth >= 768) {
                // Create Draggable only if screen width >= 768
                const draggable = Draggable.create(box, {
                    bounds: section,
                    onPress() {
                        if (active) active.classList.remove("active");
                        active = this.target;
                        active.classList.add("active");
                    },
                    zIndexBoost: false
                });
                draggableInstances.push(draggable); // Saving the instance
            }
        });
    }

    function destroyDraggable() {
        // Disable Draggable if the screen width is less than 768
        draggableInstances.forEach(instance => instance[0].kill());
        draggableInstances = []; // Clearing the instance array
    }

    gsap.set(".custom-drag-sticker", { clearProps: "transform", x: 0, y: 0 });
    // Initialization on page load
    initDraggable();

    // Checking screen width changes
    $(window).resize(function () {
        if (window.innerWidth >= 768) {
            if (draggableInstances.length === 0) {
                initDraggable(); // Initializing Draggable
            }
        } else {
            destroyDraggable(); // Turn off Draggable
        }
    });
});
